<section class="error-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <h1 i18n="@@featureErrors-pageNotFound-headline">404 - Ups!</h1>
        <p i18n="@@featureErrors-pageNotFound-text">
          Es tut uns leid, aber die gewünschte Seite steht leider nicht mehr zur Verfügung.
        </p>
        <a routerLink="/" mat-flat-button color="primary" i18n="@@featureErrors-pageNotFound-button">
          Zur Startseite
        </a>
      </div>
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone error-page-image-wrapper">
        <img src="assets/errors/notfound.svg" class="error-page-image" />
      </div>
    </div>
  </div>
</section>
